<template>
  <asc-dialog
    text="Parameter Graph"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-parameter-graph
        :definition="definition"
        :loading="loading"
        :is-series-data="isSeriesData"
        :on-date-change="onDateChange"
        :dates="dates"
      ></asc-parameter-graph>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import { AscDataDefinitionMixin, AscDialogMixin } from '@/components/mixins'
import AscParameterGraph from './AscParameterGraph'

export default {
  name: 'AscParameterGraphDialog',

  components: {
    AscDialog,
    AscParameterGraph,
  },

  mixins: [AscDialogMixin, AscDataDefinitionMixin],

  props: {
    dates: {
      type: Object,
      default: () => {},
    },
    isSeriesData: {
      type: Boolean,
      default: false,
    },
    onDateChange: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
